import React, { useEffect } from "react";
import { useRecoilValue } from "recoil";
import styled from "styled-components";
import LineBtn from "../../../../Button/LineBtn";
import { sunsetDetailButtonType } from "../SunsetDetailButtons";

interface SunsetAlimtalkCaseBtnProps {
  state: "active" | "success" | "notSelected";
  btnText: string;
  btnClickEvent: () => void;
}

export default function SunsetAlimtalkCaseBtn({
  state,
  btnText,
  btnClickEvent,
}: SunsetAlimtalkCaseBtnProps) {
  const buttonType = useRecoilValue(sunsetDetailButtonType);

  console.log(state);

  useEffect(() => {}, [state]);

  return (
    <>
      {buttonType === "view" ? (
        <LineBtn
          btnText={btnText}
          btnHeight={32}
          icon={"done"}
          sPadding="0 10px"
          btnColor={
            state === "active" || state === "success" ? "mint" : "black"
          }
          btnClickEvent={() => {
            btnClickEvent();
          }}
          btnTextColor={state === "notSelected" ? "#aaafb9" : undefined}
        />
      ) : (
        <>
          {state === "notSelected" ? (
            <NotSelectedBtn onClick={() => btnClickEvent()}>
              {btnText}
            </NotSelectedBtn>
          ) : (
            <LineBtn
              btnText={btnText}
              btnHeight={32}
              icon={state === "success" ? "done" : undefined}
              sPadding="0 10px"
              btnColor={state === "active" ? "mint" : "black"}
              btnClickEvent={() => {
                btnClickEvent();
              }}
              btnTextColor={state === "success" ? "#aaafb9" : undefined}
            />
          )}
        </>
      )}
    </>
  );
}

const NotSelectedBtn = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  border-radius: 5px;
  background-color: #ebecf0;
  padding: 0 10px;
  border: solid 1px transparent;

  font-size: 13px;
  font-weight: 500;
  line-height: 24px;
  text-align: left;
  white-space: nowrap;
  word-break: keep-all;
  color: ${({ theme }) => theme.color.gray600};
`;
